import React from 'react';
import ComplianceArchiveSection from '../../../sections/AdminDashboard/ComplianceArchive/ComplianceArchive';

const ComplianceArchive = () => {
  return <ComplianceArchiveSection />;
};

export default ComplianceArchive;

